import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AppComponent } from 'src/app/app.component';
import { FirebaseFunctionsService } from 'src/app/services/firebase-functions.service';

@Component({
  selector: 'app-activites',
  templateUrl: './activites.component.html',
  styleUrls: ['./activites.component.scss']
})
export class ActivitesComponent implements OnInit {

  activities: Observable<any>;
  activitess: any;
  constructor(private afs: FirebaseFunctionsService, private app: AppComponent) {
    this.getActivities();
  }

  ngOnInit(): void {
    setTimeout(this.app.afficherPage,2000);
    this.reinitializeMenus();
    document.querySelectorAll('.menu_activites').forEach( el => {
      el.classList.add('selected');
    });
  }
  getActivities(){
    this.activities = this.afs.getActivities();
    this.activities.subscribe( activites => {
      activites.forEach(activite => {
        activite.bgColor = (activites.indexOf(activite) % 2 == 0) ? '2949a8': 'D4AB16';
      });
      this.activitess = activites;
    });
  }
  reinitializeMenus(){
    const menusTabs = document.querySelectorAll('.menus_tab');
    menusTabs.forEach( tabs => {
      (tabs as HTMLElement).classList.remove('selected');
    })
  }
}
